<template>
  <v-container
    fluid
    fill-height
    align-center
    text-xs-center>

    <v-layout>

      <!--- Loading --->
      <v-flex
        v-if="loading"
        xs12>
        <v-progress-circular
          indeterminate
          color="primary"/>
      </v-flex>
      <v-flex
        v-else
        xs12>
        <v-card>
          <h2>{{ strings[idioma]['pagamento'].minhas_assinaturas }}</h2>
          <v-divider/>
          <h3>{{ strings[idioma]['pagamento'].assinaturas_ativas }}</h3>
          <v-card>
            <v-container
              fluid
              grid-list-md
            >
              <v-layout
                row
                wrap>
                <v-flex
                  v-for="plano in PlanosAtivos"
                  :key="plano.id"
                  lg3
                  md12
                >
                  <v-card>
                    <v-img
                      style="background: gray"
                      height="200px"
                    >
                      <v-container
                        fill-height
                        fluid
                        pa-2
                      >
                        <v-layout fill-height>
                          <v-flex
                            xs12
                            align-end
                            flexbox>
                            <span
                              class="headline white--text"
                              v-text="plano.tipo === 0 ? strings[idioma].pecuarista : plano.tipo === 1 ? strings[idioma].premium_start : strings[idioma].consultor"/>
                            <hr>
                            <span
                              class="headline white--text"
                              v-text="plano.teste === 1 ? 'Teste Grátis': '-'"/>
                            <hr>
                            <span
                              class="white--text"
                              v-text="strings[idioma].data_inicial + ': ' + formatDate(plano.data_inicio)"/>
                            <br>
                            <span
                              class="white--text"
                              v-text="strings[idioma].data_final + ': ' + formatDate(plano.data_final)"/>
                            <hr>
                            <span
                              v-if="plano.pagamento !== null"
                              class="white--text"
                              v-text="strings[idioma]['pagamento'][plano.pagamento.forma_pagamento]"/>
                            <hr>
                            <span
                              v-if="plano.pagamento !== null"
                              class="white--text"
                              v-text="strings[idioma]['pagamento'][plano.pagamento.status]"/>

                          </v-flex>

                        </v-layout>
                      </v-container>
                    </v-img>

                    <v-card-actions>
                      <v-spacer/>
                      <v-btn
                        v-if="plano.recorrente"
                        icon>
                        <v-icon
                          :title="strings[idioma]['pagamento'].CANCEL_RECURRENCE"
                          color="error"
                          @click="cancelarRecorrencia(plano)">mdi-close</v-icon>
                      </v-btn>
                      <v-btn icon>
                        <v-icon
                          :title="strings[idioma]['pagamento'].RENEW"
                          color="success"
                          @click="renovar(plano)">mdi-refresh</v-icon>

                      </v-btn>
                      <v-btn icon>
                        <v-icon @click="info(plano)">mdi-information</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
                <!-- load more -->
                <v-flex
                  v-if="planosAtivos.next_page_url !== null"
                  :key="'load-more'"
                  v-bind="{ [`xs2`]: true }">
                  <v-card>
                    <v-img
                      style="background: blue"
                      height="200px"
                    >
                      <v-container
                        fill-height
                        fluid
                        pa-2
                      >
                        <v-layout fill-height>
                          <v-flex
                            xs12
                            align-end
                            flexbox
                            @click="carregarMais">
                            <span
                              class="headline white--text"
                              v-text="'+'"
                            />
                            <hr>
                            <span
                              class="white--text"
                              v-text="strings[idioma].carregar_mais"/>
                          </v-flex>

                        </v-layout>
                      </v-container>
                    </v-img>
                    <v-card-actions>
                      <v-spacer/>
                      <v-btn
                        :disabled="loading"
                        :loading="loading"
                        color="primary"
                        dark
                        @click="carregarMais"
                      >
                        <v-icon>mdi-more</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-card>
        <v-divider/>
        <template v-if="PlanosInativos.length > 0">
          <h3>{{ strings[idioma]['pagamento'].assinaturas_inativas }}</h3>
          <v-card>
            <v-container
              fluid
              grid-list-md
            >
              <v-layout
                row
                wrap>
                <v-flex
                  v-for="plano in PlanosInativos"
                  :key="plano.id"
                  lg12
                  xs3
                >
                  <v-card>
                    <v-img
                      style="background: gray"
                      height="200px"
                    >
                      <v-container
                        fill-height
                        fluid
                        pa-2
                      >
                        <v-layout fill-height>
                          <v-flex
                            xs12
                            align-end
                            flexbox>
                            <span
                              class="headline white--text"
                              v-text="plano.tipo === 0 ? strings[idioma].pecuarista : plano.tipo === 1 ? strings[idioma].premium_start : strings[idioma].consultor"/>
                            <hr>
                            <span
                              class="headline white--text"
                              v-text="plano.teste === 1 ? strings[idioma].teste_gratis : '-'"/>
                            <hr>
                            <span
                              class="white--text"
                              v-text="strings[idioma].data_inicial + ': ' + formatDate(plano.data_inicio)"/>
                            <br>
                            <span
                              class="white--text"
                              v-text="strings[idioma].data_final + ': ' + formatDate(plano.data_final)"/>
                            <hr>
                            <span
                              v-if="plano.pagamento !== null"
                              class="white--text"
                              v-text="strings[idioma]['pagamento'][plano.pagamento.forma_pagamento]"/>
                            <hr>
                            <span
                              v-if="plano.pagamento !== null"
                              class="white--text"
                              v-text="strings[idioma]['pagamento'][plano.pagamento.status]"/>

                          </v-flex>

                        </v-layout>
                      </v-container>
                    </v-img>

                    <v-card-actions>
                      <v-spacer/>
                      <v-btn
                        v-if="plano.recorrente"
                        icon>
                        <v-icon
                          :title="'Cancelar Recorrencia'"
                          color="error"
                          @click="cancelarRecorrencia(plano)">mdi-close</v-icon>
                      </v-btn>
                      <v-btn icon>
                        <v-icon
                          :title="'Renovar'"
                          color="success"
                          @click="renovar(plano)">mdi-refresh</v-icon>
                      </v-btn>
                      <v-btn icon>
                        <v-icon @click="info(plano)">mdi-information</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
                <!-- load more -->
                <v-flex
                  v-if="planosInativos.next_page_url !== null"
                  :key="'load-more'"
                  v-bind="{ [`xs2`]: true }">
                  <v-card>
                    <v-img
                      style="background: blue"
                      height="200px"
                    >
                      <v-container
                        fill-height
                        fluid
                        pa-2
                      >
                        <v-layout fill-height>
                          <v-flex
                            xs12
                            align-end
                            flexbox
                            @click="carregarMaisInativo">
                            <span
                              class="headline white--text"
                              v-text="'+'"
                            />
                            <hr>
                            <span
                              class="white--text"
                              v-text="strings[idioma].carregar_mais"/>
                          </v-flex>

                        </v-layout>
                      </v-container>
                    </v-img>
                    <v-card-actions>
                      <v-spacer/>
                      <v-btn
                        :disabled="loading"
                        :loading="loading"
                        color="primary"
                        dark
                        @click="carregarMaisInativo"
                      >
                        <v-icon>mdi-more</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </template>
      </v-flex>

    </v-layout>
  </v-container>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  data: () => ({
    planosAtivos: [],
    planosInativos: [],
    planosAtivosRaw: [],
    loading: false,
    cards: [
      { title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 12 },
      { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 6 },
      { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 },
      { title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 12 },
      { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 6 },
      { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 }
    ]
  }),
  computed: {
    ...mapState('app', ['idioma', 'strings', 'user', 'empresa', 'acesso']),
    PlanosAtivos () {
      return this.planosAtivos ? this.planosAtivos.data : []
    },
    PlanosInativos () {
      return this.planosInativos ? this.planosInativos.data : []
    }
  },
  created () {
    Promise.all([
      this.axios.post('pagamento/plano/ativos'),
      this.axios.post('pagamento/plano/inativos')
    ]).then(r => {
      let [planosAtivos, planosInativos] = r
      if (planosAtivos.data && planosAtivos.data.data) this.planosAtivos = planosAtivos.data.data
      if (planosInativos.data && planosInativos.data.data) this.planosInativos = planosInativos.data.data
      this.planosAtivos.data.map(plano => {
        plano.recorrente = plano.pagamento && plano.pagamento.id_assinatura_asaas !== null && plano.pagamento.periodicidade !== null
      })
      this.planosInativos.data.map(plano => {
        plano.recorrente = plano.pagamento && plano.pagamento.id_assinatura_asaas !== null && plano.pagamento.periodicidade !== null
      })
      console.log({ pa: this.planosAtivos, pi: this.planosInativos })
    })
  },
  methods: {
    formatDate (date) {
      return moment(date).format(this.strings[this.idioma].formato_datas_sem_hora)
    },
    info (plano) {
      if (plano.tipo === 2) {
        window.open('https://loja.brcorte.com.br/produto/assinatura-br-corte-premium-consultor/', '_blank')
      } else if (plano.tipo === 1) {
        window.open('https://loja.brcorte.com.br/produto/assinatura-br-corte-premium-start/', '_blank')
      } else {
        window.open(`https://loja.brcorte.com.br/`, '_blank')
      }
    },
    renovar (plano) {
      if (confirm('Deseja renovar o plano?')) {
        window.open(this.axios.defaults.baseURL + `pagamento/` + btoa(this.user.id) + `/` + btoa('BR_' + String(plano.tipo + 1).padStart(3, '0') + '_1Y'), '_blank')
      }
    },
    cancelarRecorrencia (plano) {
      if (confirm('Deseja cancelar a recorrencia?')) {
        this.axios.post('pagamento/plano/cancelarRecorrencia', {
          id_plano: plano.id
        }).then(r => {
          
        })
      }
    },
    carregarMais () {
      this.loading = true
      this.axios.post(this.planosAtivos.next_page_url).then(r => {
        let planosAtivos = r.data.data
        console.log(planosAtivos)
        this.planosAtivos.next_page_url = planosAtivos.next_page_url
        this.planosAtivos.current_page = planosAtivos.current_page
        if (planosAtivos.data) this.planosAtivos.data = [...this.planosAtivos.data, ...planosAtivos.data]
        this.loading = false
      })
    },
    carregarMaisInativo () {
      this.loading = true
      this.axios.post(this.planosInativos.next_page_url).then(r => {
        let planosInativos = r.data.data
        console.log(planosInativos)
        this.planosInativos.next_page_url = planosInativos.next_page_url
        this.planosInativos.current_page = planosInativos.current_page
        if (planosInativos.data) this.planosInativos.data = [...this.planosInativos.data, ...planosInativos.data]
        this.loading = false
      })
    }
  }
}
</script>
